import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, Subject, Subscription } from "rxjs";
import { EstatusJSON } from "../../models/EstatusJSON";
import { environment } from "src/environments/environment";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { IApiBase } from "./Interface/IApiBase.interface";

@Injectable({
  providedIn: "root",
})
export class RoleAPIService implements IApiBase{
  
  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
    this.estatus = new EstatusJSON();
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }

  getRoles(): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Roles/GetList");
  }


  delete(RoleId): any{
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Roles/DeleteRole?roleId="+RoleId);
  }

  getUpdateRole(id: string): Observable<EstatusJSON>{
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Roles/GetUpdateRole?roleId="+id);
  }

  postInsertRole(formData: any): Observable<EstatusJSON> {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Roles/PostInsertRole", formData);
  }

  postUpdateRole(formData: any): Observable<EstatusJSON> {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Roles/PostUpdateRole", formData);
  }

  //paginacion
  getFilterValues(request : FilterRequest[]) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Roles/GetFilterValues", request);
  }

  getPage(pageRequest: CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Roles/GetPage", pageRequest);
  }

  getCount(pageRequest: CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Roles/GetCount", pageRequest);
  }

  
}
